import { Box, LinkBox, LinkOverlay, Stack, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { search_result_clicked } from '@/analytics';
import { SearchHelpers } from '@/client/legacy-shared-modules/search/helpers';
import { IFileSearch } from '@/client/legacy-shared-modules/search/search-types';
import { CustomHighlight } from '@/components/CustomHighlight';
import { FileIcon } from '@/imports/ui/chakra/feather';

export const File: React.FC<{
  hit: IFileSearch;
  query?: string;
  position?: number;
}> = ({ hit, query, position }) => {
  const bodyPlainTextMatchedWords =
    ((hit as unknown as {
      _highlightResult?: {
        bodyPlainText?: {
          matchedWords?: string[];
        };
      };
    })._highlightResult?.bodyPlainText?.matchedWords ?? []);

  const handleClick = () => {
    search_result_clicked({
      entity: {
        id: hit.objectID,
        type: 'file',
      },
      search: {
        query: query || '',
        searchType: 'files',
      },
      engagement: {
        position,
      },
    });
  };

  return (
    <LinkBox
      as={Stack}
      direction="row"
      spacing="2"
      alignItems="center"
      p="2"
      bg="white"
      _hover={{ bg: 'gray.100' }}
      borderRadius="xl"
      cursor="pointer"
      onClick={handleClick}
    >
      {/* TODO: get different icon depending on file type */}
      <FileIcon boxSize="8" />

      <Box>
        <LinkOverlay as={NextLink} href={SearchHelpers.getFileUrl(hit)}>
          <Text noOfLines={1} textStyle="bodyStrong">
            <CustomHighlight attribute="file.name" hit={hit} />
          </Text>
        </LinkOverlay>

        {hit.displayName && (
          <Text noOfLines={1} textStyle="compact" color="gray.700">
            {hit.displayName}
          </Text>
        )}

        {bodyPlainTextMatchedWords.length > 0 && (
          <Text noOfLines={1} textStyle="compact" color="gray.600">
            {bodyPlainTextMatchedWords.map((word, index) => (
              <React.Fragment key={`${word}-${index}`}>
                {index > 0 ? ' ' : ''}
                <Box as="span" bg="blue.100" borderRadius="sm" px="0.5">
                  {word}
                </Box>
              </React.Fragment>
            ))}
          </Text>
        )}
      </Box>
    </LinkBox>
  );
};
